// extracted by mini-css-extract-plugin
module.exports = {"title":"view-terms_title__2acjC","blurb":"view-terms_blurb__1Oz1H","link":"view-terms_link__35BxO"};